module.exports = __webpack_public_path__ + "img/longestHS.dce458fa.png";